<div class="news-title-container score-focus">
  <div class="news-title" *ngIf="auditData">
    <div class="cont">
      <div class="cont-left">
        <ng-container *ngIf="routing.isMarket()">
          <div
            class="select"
            *ngIf="
              params.type &&
              (params.type === 'company' ||
                params.type === 'country' ||
                params.type === 'pne') &&
              auth.featureFlags.addEntities
            "
            [matMenuTriggerFor]="menu"
            matTooltip="Add entity to portfolio"
          >
            <mat-icon>add</mat-icon>
          </div>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="appendItem('add')">
              Add entity to existing portfolios
            </button>
            <button mat-menu-item (click)="appendItem('create')">
              Add entity to a new portfolio
            </button>
          </mat-menu>
          <div class="text">
            <span class="tipo"
              ><span style="font-weight: normal"
                >{{ auditData.entity.type | nicetxt: false }}:</span
              >
              {{ auditData.entity.name | nicetxt: false }}</span
            >
            <span
              class="alert-container"
              *ngIf="
                auditData.entity.sanctions?.length > 0 &&
                auth.featureFlags.showSanctions
              "
            >
              <mat-icon
                class="sanctions-alert-icon"
                svgIcon="alert"
                matTooltip="Sanctioned Entity. Click Icon for detailed Sanction Lists Data."
                (click)="$event.stopPropagation(); openDialog(auditData.entity)"
                [class.theme-light]="theme === 'light'"
              ></mat-icon>
            </span>
          </div>
        </ng-container>

        <ng-container *ngIf="routing.isFolio()">
          <div
            class="select"
            #menuTrigger="matMenuTrigger"
            [matMenuTriggerFor]="menu"
            matTooltip="Select entity"
          >
            <mat-icon *ngIf="!menuTrigger.menuOpen">arrow_drop_down</mat-icon>
            <mat-icon *ngIf="menuTrigger.menuOpen">arrow_drop_up</mat-icon>
          </div>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="select('overall')">Overall</button>
            <button
              mat-menu-item
              (click)="select(entity)"
              *ngFor="let entity of entities | orderBy: 'name'"
            >
              {{ entity.type | nicetxt: false }} :
              {{ entity.name | nicetxt: false }}
            </button>
          </mat-menu>
          <div class="text">
            <span class="tipo"
              ><span style="font-weight: normal"
                >{{ auditData.entity.type | nicetxt: false }}:</span
              >
              {{ auditData.entity.name | nicetxt: false }}</span
            >
            <span
              class="alert-container"
              *ngIf="
                auditData.entity.sanctions?.length > 0 &&
                auth.featureFlags.showSanctions
              "
            >
              <mat-icon
                class="sanctions-alert-icon"
                svgIcon="alert"
                matTooltip="Sanctioned Entity. Click Icon for detailed Sanction Lists Data."
                (click)="$event.stopPropagation(); openDialog(auditData.entity)"
                [class.theme-light]="theme === 'light'"
              ></mat-icon>
            </span>
          </div>
        </ng-container>
      </div>

      <!-- Loading spinner for score section -->
      <div class="cont-right" *ngIf="loading">
        <div class="info score-loading">
          <mat-spinner [diameter]="20"></mat-spinner>
        </div>
      </div>

      <!-- Score and flags section -->
      <ng-container *ngIf="!loading">
        <div
          *ngIf="auth.scorelabSettings.defaultFlag && auditData.showWarningFlag"
          class="cont-right"
        >
          <div
            class="info flag warning"
            [matTooltip]="getFlagTooltip('warning')?.tooltip"
          >
            <mat-icon>flag</mat-icon>
          </div>
        </div>

        <div
          *ngIf="
            auth.scorelabSettings.defaultFlag &&
            !auditData.showWarningFlag &&
            auditData.showCautionFlag
          "
          class="cont-right"
        >
          <div
            class="info flag caution"
            [matTooltip]="getFlagTooltip('caution')?.tooltip"
          >
            <mat-icon>flag</mat-icon>
          </div>
        </div>

        <div
          *ngIf="
            [
              'esg',
              'eb_sim',
              'eb_sim_risk',
              'general_risk',
              'esg_risk',
              'immediate_risk',
              'credit_risk',
              'bb',
            ].includes(this.customScore) &&
            auditData.industryBenchmarkScore !== null &&
            params.type &&
            params.type === 'company'
          "
          class="cont-right"
        >
          <div
            class="info flag bench"
            [matTooltip]="auditData.industryBenchmarkDescription"
          >
            <mat-icon
              *ngIf="auditData.industryBenchmarkScore === 0"
              svgIcon="timer-sand-full"
              class="laggard"
            ></mat-icon>
            <mat-icon
              *ngIf="auditData.industryBenchmarkScore === 1"
              svgIcon="trending-down"
              class="below"
            ></mat-icon>
            <mat-icon
              *ngIf="auditData.industryBenchmarkScore === 2"
              svgIcon="trending-up"
              class="above"
            ></mat-icon>
            <mat-icon
              *ngIf="auditData.industryBenchmarkScore === 3"
              svgIcon="medal"
              class="leader"
            ></mat-icon>
          </div>
        </div>

        <div class="cont-right">
          <div
            class="info"
            *ngIf="
              !auditData.hasOwnProperty('score') && !(auditData.score === null)
            "
            [style.color]="auditData.sentiment.sentiment | color"
          >
            <span>{{ auditData.sentiment.sentiment | percent }}</span>
            <div class="trendicon">
              <span class="brak">(</span>
              <span>{{
                auditData.sentiment.sentiment_delta * 100 | round | trend
              }}</span>
              <span>{{
                auditData.sentiment.sentiment_delta * 100 | round | negative
              }}</span>
              <span class="brak">)</span>
            </div>
          </div>

          <div class="info" *ngIf="auditData.score === null">
            <span>--</span>
          </div>
          <div
            class="info audit thing"
            *ngIf="
              auditData.hasOwnProperty('score') &&
              !['bb'].includes(this.customScore)
            "
            [style.color]="
              auth.getScoreType() === 'pos'
                ? (auditData.score | colorScore2)
                : (auditData.score | colorScore)
            "
          >
            <span>{{ auditData.score }}</span>
          </div>
          <div
            class="info"
            *ngIf="
              auditData.hasOwnProperty('score') &&
              ['bb'].includes(this.customScore) &&
              !(routing.isFolio() && !params.type)
            "
          >
            <span class="icon">
              <img
                *ngIf="auditData.trend_type === 'bear'"
                src="assets/icon/bear.svg"
              />
              <img
                *ngIf="auditData.trend_type === 'bull'"
                src="assets/icon/bull.svg"
              />
            </span>
            <span>{{ auditData.trend_value }}</span>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
